import React from 'react'

const Cta = () => {
    return (
        <div className="cta">
            <a href="#contact" className="btn btn-primary">BOOK NOW</a>
        </div>
    )
}
export default Cta
